var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NextMaterialSection',{attrs:{"learnMoreButtonMode":"anchor","title":"Wir uber uns","image-src":"main2.jpg"}}),_c('CanWeHelpSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }